import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { clearEmptyProperties } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import english from './../i18n/en.json';
import spanish from './../i18n/es.json';
import portuguese from './../i18n/pt.json';
var FiltersComponent = /** @class */ (function () {
    function FiltersComponent(fuseTranslationLoaderService, formBuilder) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.formBuilder = formBuilder;
        this.filterChanged = new BehaviorSubject({ archived: false });
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FiltersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.filtersForm = this.formBuilder.group({
            name: null,
            archived: false
        });
        this.filtersForm.valueChanges.pipe(debounceTime(500), tap(function () {
            var filters = clearEmptyProperties({
                name_contains: _this.filtersForm.value.name,
                archived: _this.filtersForm.value.archived
            });
            _this.filterChanged.next(filters);
        })).subscribe();
    };
    FiltersComponent.prototype.clearFilters = function () {
        this.filtersForm.patchValue({
            name: null,
            archived: false
        });
    };
    return FiltersComponent;
}());
export { FiltersComponent };
